// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge-6"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6 20V13M6 13H2M6 13H18M2 13V20M2 13V4L11.4444 12.5M18 13V20M18 13H22M22 13V20M22 13V4L12.5556 12.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge-6')
export default class Bridge6Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-6',
    }
  }
}
